import React from "react";
import { Fade } from "react-awesome-reveal";
import {
  TbBuildingFactory2,
  TbCode,
  TbArrowRight,
  TbChartBar,
  TbCpu,
  TbBox,
  TbBrain,
  TbPuzzle,
} from "react-icons/tb";
import "../../styles/SegmentationSection.css";

/* Smooth scroll helper */
const scrollTo = (id, offset = 80) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: "smooth" });
};

const tracks = [
  {
    id: "industrial",
    icon: <TbBuildingFactory2 size={28} />,
    label: "Operación industrial",
    tagline: "Optimizá y controlá tu planta o empresa con soluciones probadas en producción real.",
    cta: "Ver soluciones industriales",
    scrollId: "sol-erp",
    accent: "#7c3aed",
    accentBg: "rgba(124,58,237,0.08)",
    accentBorder: "rgba(124,58,237,0.25)",
    solutions: [
      { icon: <TbBuildingFactory2 size={16} />, label: "ERP Industrial" },
      { icon: <TbCpu size={16} />,              label: "MES" },
      { icon: <TbBox size={16} />,              label: "Gemelo Digital" },
    ],
  },
  {
    id: "custom",
    icon: <TbCode size={28} />,
    label: "Sistema propio",
    tagline: "Diseñá y desarrollá una plataforma a medida que refleje exactamente tu modelo de negocio.",
    cta: "Ver desarrollo a medida",
    scrollId: "sol-dev",
    accent: "#059669",
    accentBg: "rgba(5,150,105,0.08)",
    accentBorder: "rgba(5,150,105,0.25)",
    solutions: [
      { icon: <TbPuzzle size={16} />, label: "Desarrollo a Medida" },
      { icon: <TbBrain size={16} />,  label: "IA Integrada" },
      { icon: <TbChartBar size={16} />, label: "Analytics & Dashboards" },
    ],
  },
];

const SegmentationSection = () => (
  <section className="seg-root" id="desafio">
    <div className="container">

      {/* Badge */}
      <Fade direction="down" triggerOnce duration={700}>
        <div className="eco-badge mx-auto mb-4">
          ¿Qué desafío tiene tu empresa?
        </div>
      </Fade>

      {/* Headline */}
      <Fade direction="up" triggerOnce duration={800} delay={100}>
        <h2 className="eco-main-title text-center text-white">
          Elegí el camino{" "}
          <span className="highlight">que se ajusta a tu operación.</span>
        </h2>
      </Fade>

      <Fade direction="up" triggerOnce duration={700} delay={200}>
        <p className="eco-main-sub text-center text-white">
          No todos los negocios tienen el mismo punto de partida.
          Identificá tu desafío y te mostramos exactamente qué soluciones aplicar.
        </p>
      </Fade>

      {/* Track cards */}
      <div className="seg-grid">
        {tracks.map((t, i) => (
          <Fade direction="up" triggerOnce duration={700} delay={300 + i * 120} key={t.id}>
            <div
              className="seg-card"
              style={{
                "--seg-accent":      t.accent,
                "--seg-accent-bg":   t.accentBg,
                "--seg-accent-border": t.accentBorder,
              }}
            >
              {/* Header */}
              <div className="seg-card-header">
                <span className="seg-icon">{t.icon}</span>
                <div>
                  <h3 className="seg-label">{t.label}</h3>
                  <p className="seg-tagline">{t.tagline}</p>
                </div>
              </div>

              {/* Solutions inside this track */}
              <ul className="seg-solutions">
                {t.solutions.map((s) => (
                  <li key={s.label} className="seg-solution-item">
                    <span className="seg-sol-icon">{s.icon}</span>
                    <span>{s.label}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <button
                type="button"
                className="seg-cta"
                onClick={() => scrollTo(t.scrollId)}
              >
                {t.cta}
                <TbArrowRight size={16} />
              </button>
            </div>
          </Fade>
        ))}
      </div>

    </div>
  </section>
);

export default SegmentationSection;
